module.exports = __webpack_public_path__ + "974c1298f9cc4f25a3772c2053d200c6.pdf";